import { Box, Card, Grid, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { Fragment, useEffect, useState } from 'react';
import ReviewOtpIcon from '../../../icons/ReviewOtpIcon.svg';
import TableHeader from '../../shared/TableHeader';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { AnnouncementState, getSentAnnouncements, selectAnnouncementsState } from '../sagas/announcementSlice';
import BadRequestIcon from '../../../icons/Badrequesterror.svg';
import Error500 from '../../../icons/505Error.svg';
import SpinnerWithNoConfirmation from '../../../shared/Modal/spinnerWithNoConfirmation';
import { SearchSentAnnouncementsDto } from '@inosio/payments-sdk';
import { CreateNewAnnouncementButton } from './CreateNewAnnouncementButton';
import { convertToHumanReadable } from '../../../utils/string-util';
import { format } from 'date-fns';

export const SentAnnouncements = () => {
  const dispatch = useDispatch();
  const { SentAnnouncementsDataPages, isFetchingSentAnnouncements, SentAnnouncementsFetchError, SentAnnouncementResponseDto }: AnnouncementState = useSelector(selectAnnouncementsState);
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(0);
  const [rangeSize, setRangeSize] = useState(100);
  const [recordStartIndex, setRecordStartIndex] = useState(0);
  const [searchField, setSearchField] = React.useState('Keyword');
  const [searchValue, setSearchValue] = React.useState('');
  const searchValueInputRef = React.createRef<HTMLInputElement>();
  const columnsSelectRef = React.createRef<HTMLSelectElement>();
  const [columnFilterSearchField, setColumnFilterSearchField] = React.useState('');
  const [isSearchValueEmpty, setIsSearchValueEmpty] = React.useState(false);
  const matchesMobile = useMediaQuery('(max-width:420px)');
  const history = useHistory();
  const optionValues = [{ key: 'Keyword', value: 'Keyword' }];
  const [searchBluePillValue, setSearchPillValue] = React.useState('');
  const [searchChipOpen, setSearchChipOpen] = React.useState(false);

  const setSearchPageIndex = (pageNumber: number) => {
    if (!SentAnnouncementsDataPages[pageNumber]?.Rows) {
      const newIndex = pageNumber * rangeSize;
      setRecordStartIndex(newIndex);
    }
  };

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPageNumber: number) => {
    setSearchPageIndex(newPageNumber);
    setCurrentPage(newPageNumber);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setCurrentPage(0);
    setRecordStartIndex(0);
    setRangeSize(parseInt(event.target.value));
  };

  const searchValueChangeHandler = (e: any) => {
    setSearchValue(e.target.value ? e.target.value.trim() : '');
  };

  const searchFieldChangeHandler = (e: any) => {
    setSearchField(e.target.value);
  };

  const handleChooseColumnSearchField = (event: any) => {
    event.preventDefault();
    if (columnsSelectRef.current) {
      setColumnFilterSearchField(columnsSelectRef?.current?.value);
    }
  };

  const resetTableRows = () => {
    setSearchValue('');
    setSearchField('Keyword');
    setRecordStartIndex(0);
    setCurrentPage(0);
    setSearchPillValue('');
    setSearchChipOpen(false);
    handleSearches(rangeSize, 0);
  };

  const handleSearch = (event: any) => {
    setCurrentPage(0);
    setRecordStartIndex(0);
    setSearchChipOpen(true);
    event.preventDefault();
    if (searchValueInputRef?.current && searchValueInputRef?.current?.value?.length !== 0) {
      setSearchPillValue(searchValueInputRef?.current?.value);
    }
    if (searchValueInputRef?.current?.value.length !== 0) {
      handleSearches(rangeSize, 0, searchField, searchValue);
    } else {
      handleSearches(rangeSize, 0);
    }
  };

  useEffect(() => {
    if (searchValue.length === 0) {
      setIsSearchValueEmpty(true);
    } else {
      setIsSearchValueEmpty(false);
    }
  }, [searchValue]);

  const getErrorIcon = (statusCode: number | undefined) => {
    if (String(statusCode)[0] === '4') {
      return BadRequestIcon;
    } else {
      return Error500;
    }
  };

  useEffect(() => {
    handleSearches(rangeSize, recordStartIndex);
  }, [dispatch, recordStartIndex, rangeSize]);

  const handleSearches = (rangeSize: number, startIndex: number, searchField?: string, searchValue?: string) => {
    const searchAnnouncementsParamsDto: SearchSentAnnouncementsDto = {
      RangeSize: rangeSize,
      StartIndex: startIndex,
      Keyword: searchValue,
    };
    dispatch(getSentAnnouncements(searchAnnouncementsParamsDto));
  };

  return (
    <Grid item xs={12} sx={{ mt: 3.5 }}>
      <Card
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          height: 'calc( 100vh - 144px )',
          pb: '64px',
        }}
        className={classes.gridContainer}
        style={{ position: 'relative' }}
      >
        <Fragment>
          <Box sx={{ display: 'flex', p: 0, pb: 1, justifyContent: 'space-between', '& .MuiTextField-root': { m: 1, width: '25ch' }, flexDirection: matchesMobile ? 'column-reverse' : 'row' }}>
            <TableHeader
              searchValueChangeHandler={searchValueChangeHandler}
              searchValue={searchValue}
              isSearchValueEmpty={isSearchValueEmpty}
              searchFieldChangeHandler={searchFieldChangeHandler}
              searchField={searchField}
              optionValues={optionValues}
              handleSearch={handleSearch}
              columnsSelectRef={columnsSelectRef}
              handleChooseColumnSearchField={handleChooseColumnSearchField}
              resetTableRows={resetTableRows}
              resetSearchFilter={(value) => setSearchField('Keyword')}
              resetSearchValue={setSearchValue}
              columnFilterSearchField={columnFilterSearchField}
              searchValueInputRef={searchValueInputRef}
              rangeSize={rangeSize}
              recordStartIndex={recordStartIndex}
              hideCalendarIcon={true}
              hideDateRangeSearchPillChip={true}
              hideCalendarModal={true}
              hideSearchInput={true}
              searchBluePillValue={searchBluePillValue}
              setSearchChipOpen={setSearchChipOpen}
              searchChipOpen={searchChipOpen}
            />
            <Box>
              <CreateNewAnnouncementButton />
            </Box>
          </Box>
          {SentAnnouncementsFetchError.statusCode ? (
            <Grid container direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
              <Grid item display="flex" flexDirection="column" alignItems="center">
                <Grid item display="flex" justifyContent="center" sx={{ marginLeft: '5%' }}>
                  <img src={getErrorIcon(SentAnnouncementsFetchError?.statusCode)} alt={String(SentAnnouncementsFetchError?.statusCode)} style={{ height: '35vh' }} />
                </Grid>
                <Grid item justifyContent="center">
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 700,
                      fontSize: '40px',
                      lineHeight: '23px',
                      color: '#2E82AF',
                      textAlign: 'center',
                      marginTop: '10px',
                    }}
                  >
                    {SentAnnouncementsFetchError?.statusCode}
                  </Typography>
                </Grid>
                {SentAnnouncementsFetchError?.statusCode === 404 && (
                  <Grid mt={2} item justifyContent="center">
                    <Typography
                      sx={{
                        fontFamily: 'Work Sans',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        fontSize: '20px',
                        lineHeight: '23px',
                        color: '#9E9E9E',
                        textAlign: 'center',
                        marginTop: '10px',
                      }}
                    >
                      Page not found.
                    </Typography>
                  </Grid>
                )}
                <Grid item justifyContent="center" mt={2} xs={8}>
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '23px',
                      color: '#9E9E9E',
                      textAlign: 'center',
                      marginTop: '10px',
                    }}
                  >
                    {SentAnnouncementsFetchError?.message?.length === 0 ? '' : SentAnnouncementsFetchError?.message}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ) : isFetchingSentAnnouncements ? (
            <Stack
              justifyContent="center"
              alignItems="center"
              style={{
                height: '1100px',
              }}
            >
              <SpinnerWithNoConfirmation />
            </Stack>
          ) : (
            <TableContainer style={{ flex: 1 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left" id="subTitle">
                      Description
                    </TableCell>
                    <TableCell align="left" id="subTitle">
                      Type
                    </TableCell>
                    <TableCell align="center" id="subTitle">
                      Recipients
                    </TableCell>
                    <TableCell align="center" id="subTitle">
                      Last Sent
                    </TableCell>
                    <TableCell align="center" id="subTitle">
                      Details
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {SentAnnouncementsDataPages?.[currentPage]?.Rows?.length ? (
                    SentAnnouncementsDataPages?.[currentPage]?.Rows?.map((sentAnnouncement) => (
                      <TableRow key={sentAnnouncement.EventUuid} sx={{ '&:last-child td, &:last-child th': { border: 0 }, m: 0 }}>
                        <TableCell component="th" scope="row" id="content">
                          {sentAnnouncement.Description}
                        </TableCell>
                        <TableCell align="left" id="content">
                          {convertToHumanReadable(sentAnnouncement.Frequency)}
                        </TableCell>
                        <TableCell width={'30%'} align="center" id="content">
                          {sentAnnouncement?.RecipientOptions?.map((option) => convertToHumanReadable(option))?.join(', ')}
                        </TableCell>
                        <TableCell align="center" id="content">{format(new Date(sentAnnouncement.SentDate)!, `MM/dd/yyyy hh:mm a`)}</TableCell>
                        <TableCell align="center">
                          <Tooltip title={'View Announcement Detail'} placement="top">
                            <img
                              src={ReviewOtpIcon}
                              style={{ cursor: 'pointer', fontSize: '18px' }}
                              alt="View Summary"
                              onClick={() => {
                                history.push(`/pmui/announcements/${sentAnnouncement.EventUuid}/summary`);
                              }}
                            />
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <></>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          <TablePagination
            component="div"
            rowsPerPageOptions={[10, 50, 100, 200]}
            count={SentAnnouncementResponseDto.TotalCount ?? 0}
            page={currentPage}
            onPageChange={handleChangePage}
            rowsPerPage={rangeSize}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{ position: 'absolute', bottom: 10, right: 10 }}
          />
        </Fragment>
      </Card>
    </Grid>
  );
};

const useStyles = makeStyles({
  gridContainer: {
    background: '#FFFFFF',
    borderRadius: '24px',
  },
  dialog: {
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttontext: {
    fontFamily: 'sans-serif',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 'small',
  },
  dialogbox: {
    borderRadius: '20',
    borderStyle: 'solid',
  },
  avatarGroupRoot: {
    marginLeft: '14px',
    '& .MuiAvatar-root': {
      width: 24,
      height: 24,
      fontFamily: 'Work Sans !important',
      fontStyle: 'normal !important',
      fontWeight: '400 !important',
      fontSize: '10px !important',
      lightHeight: '18px !important',
      marginLeft: '-12px !important',
    },
  },
  avatarRoot: {
    '&.MuiAvatar-root': {
      width: 24,
      height: 24,
      fontFamily: 'Work Sans !important',
      fontStyle: 'normal !important',
      fontWeight: '400 !important',
      fontSize: '10px !important',
      lightHeight: '18px !important',
      marginLeft: '-12px !important',
    },
  },
});
